import React, { useEffect, useMemo } from 'react'
import {
    Box,
    Button,
    Grid, IconButton, Typography,
} from '@material-ui/core'
import { attributes, categories, modelOptionTypes, models, options } from '../../../../store/slices'
import { useAppDispatch, useAppSelector } from '../../../../store'
import { SideBar } from '../../../../components/side-bar'
import { Content } from '../../../../components/content'
import { Field, FieldArray, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { FileField } from '../../../../components/fileField'
import { useStyles } from '../index.style'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { useSelector } from 'react-redux'
import { SelectField } from '../../../../components/selectField'
import { navLinksProduct, validation } from '../../../../services'
import { SelectFieldMultiple } from '../../../../components/selectFieldMultiple'
import { NumericField } from '../../../../components/numericField'
import { useHistory } from 'react-router-dom'
import { unwrapResult } from '@reduxjs/toolkit'
import { ROUTES } from '../../../../constants'
import { SelectedOptionValuesField } from '../create'
import { emptyProductPrice, ProductPriceField } from '../../../../components/productPriceField'


interface ModelEditPageProps {
    match: {
        params: {
            id: string
        }
    }
}

export function ModelEditPage(props: ModelEditPageProps): JSX.Element {

    const model = useAppSelector((state) => models.selectors.selectById(state, props.match.params.id))

    useEffect(() => {
        dispatch(models.actions.fetch())
        dispatch(categories.actions.fetch())
        dispatch(attributes.actions.fetch())
        dispatch(options.actions.fetch())
        dispatch(modelOptionTypes.actions.fetch())
    }, [])

    const classes = useStyles()

    const dispatch = useAppDispatch()
    const history = useHistory()

    const categoriesList = useSelector(categories.selectors.selectAll)
    const attributesList = useSelector(attributes.selectors.selectAll)
    const optionsList = useSelector(options.selectors.selectAll)
    const modelOptionTypesList = useSelector(modelOptionTypes.selectors.selectAll)

    const categoryItems = useMemo(() => categoriesList.map((item) => ({value: item.iri, label: item.name})), [categoriesList])
    const attributesItems = useMemo(() => attributesList.map((item) => ({value: item.iri, label: item.name})), [attributesList])
    const optionsItems = useMemo(() => optionsList.map((item) => ({value: item.iri, label: item.name})), [optionsList])
    const modelOptionTypeItems = useMemo(() => modelOptionTypesList.map((item) => ({value: item.iri, label: item.text})), [modelOptionTypesList])

    // const emptyModelOptionValue = {
    //     value: '',
    //     image: null
    // }

    const emptyModelOption = {
        type: '',
        option: '',
        values: [],
        priority: 100
    }

    const emptyModelAttribute = {
        attribute: null,
        value: '',
        priority: 100,
    }

    // чот жопное говно - подумать
    // санек сказал надо сделать трансформер для выдачи энитити чтобы типа энтити с трансформером сразу захуячивались и делалпсь инишл модель
    const initialModel = {
        id: model?.id || '',
        iri: model?.iri || '',
        name: model?.name || '',
        description: model?.description || '',
        mainCategory: model?.mainCategory?.iri || null,
        categories: model?.categories?.map( (item) => item.iri ) || [],
        mainImage: model?.mainImage || null,
        images: model?.images || [],
        modelOptions: model?.modelOptions?.map( (item) => ({
            type: item?.type?.iri,
            option: item?.option,
            values: item?.values?.map( (itemValue) => itemValue.iri  ) || [],
            priority: item?.priority,
        }) ) || [],
        modelAttributes: model?.modelAttributes || [],
        prices: model?.prices?.map( (item) => ({
            ...item,
            type: item.type.iri,
        }) ) || []
    }

    return (
        <Formik
            initialValues={initialModel}
            enableReinitialize
            onSubmit={(values, { setSubmitting }) => {

                const data = {
                    ...values,
                    prices: values.prices.map( (price) => ({
                        ...price,
                        actionPrice: price.actionPrice ? price.actionPrice * 100 : price.actionPrice,
                    }))
                }

                dispatch(models.actions.update({iri: values.iri, data: data}))
                    .then(unwrapResult)
                    .then(() => {
                        history.push(ROUTES.PRODUCT_MODELS)
                    })
                setSubmitting(false)
            }}
        >
            {({ submitForm, values: model }) => (
                <Form>
                    <Box display="flex">
                        <SideBar navLinks={navLinksProduct}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={submitForm}
                            >
                                Сохранить
                            </Button>
                        </SideBar>
                        <Content loading={false} notFoundContent={false} title={'Редактирование модели'}>
                            <Grid container spacing={2}>
                                <Grid item xs={3}>
                                    <Field
                                        component={TextField}
                                        label="Название"
                                        name="name"
                                        fullWidth
                                        required
                                        validate={validation.required}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <Field
                                        component={TextField}
                                        label="Описание"
                                        name="description"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <Field
                                        label='Основная категория'
                                        name='mainCategory'
                                        component={SelectField}
                                        fullWidth
                                        nullable
                                        nullableText={'Не выбрано'}
                                        items={categoryItems}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <Field
                                        label='Дополнительные категории'
                                        name='categories'
                                        component={SelectFieldMultiple}
                                        fullWidth
                                        items={categoryItems}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} className={classes.section}>
                                <Grid item xs={6}>
                                    <Typography variant="h6">Доступные атрибуты</Typography>
                                    { !model.modelAttributes.length && <p>Пока пусто</p> }
                                    <FieldArray
                                        name="modelAttributes"
                                        render={(arrayHelpers) => (
                                            <>
                                                {model.modelAttributes.map((value, index) => {
                                                    const selectedAttribute = value.attribute ? attributesList.find((attribute) => attribute.iri === value.attribute) : null
                                                    const selectedAttributeValues = selectedAttribute ? selectedAttribute.values?.map((value) => ({value: value, label: value})) : null
                                                    return (
                                                        <Grid key={index} container spacing={2}>
                                                            <Grid item xs={4}>
                                                                <Field
                                                                    label="Атрибут"
                                                                    name={`modelAttributes[${index}].attribute`}
                                                                    component={SelectField}
                                                                    fullWidth
                                                                    required
                                                                    validate={validation.required}
                                                                    nullableText={'Не выбрано'}
                                                                    items={attributesItems}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                {selectedAttribute && selectedAttributeValues ?
                                                                    <Field
                                                                        component={SelectField}
                                                                        label="Значение"
                                                                        name={`modelAttributes[${index}].value`}
                                                                        fullWidth
                                                                        required
                                                                        validate={validation.required}
                                                                        items={selectedAttributeValues}
                                                                    />
                                                                    :
                                                                    <Field
                                                                        component={TextField}
                                                                        label="Значение"
                                                                        name={`modelAttributes[${index}].value`}
                                                                        fullWidth
                                                                        required
                                                                        validate={validation.required}
                                                                    />
                                                                }
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <Field
                                                                    component={NumericField}
                                                                    label="Приоритет"
                                                                    name={`modelAttributes[${index}].priority`}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <IconButton
                                                                    onClick={() => arrayHelpers.remove(index)}
                                                                >
                                                                    <HighlightOffIcon/>
                                                                </IconButton>

                                                            </Grid>
                                                        </Grid>
                                                    )
                                                }
                                                )}
                                                <Button
                                                    fullWidth={true}
                                                    style={{marginTop: 10}}
                                                    onClick={() => arrayHelpers.push({...emptyModelAttribute})}
                                                >
                                                    Добавить атрибут
                                                </Button>
                                            </>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="h6">Доступные опции</Typography>
                                    { !model.modelOptions.length && <p>Пока пусто</p> }
                                    <FieldArray
                                        name="modelOptions"
                                        render={(arrayHelpers) => (
                                            <>
                                                {model.modelOptions.map((modelOption, index) => (
                                                    <Grid key={index} container spacing={2}>
                                                        <Grid item xs={4}>
                                                            <Field
                                                                label='Опция'
                                                                name={`modelOptions[${index}].option`}
                                                                component={SelectField}
                                                                fullWidth
                                                                required
                                                                validate={validation.required}
                                                                nullableText={'Не выбрано'}
                                                                items={optionsItems}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <Field
                                                                label='Тип'
                                                                name={`modelOptions[${index}].type`}
                                                                component={SelectField}
                                                                fullWidth
                                                                required
                                                                validate={validation.required}
                                                                nullableText={'Не выбрано'}
                                                                items={modelOptionTypeItems}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <Field
                                                                label='Значения'
                                                                name={`modelOptions[${index}].values`}
                                                                component={SelectedOptionValuesField}
                                                                fullWidth
                                                                required
                                                                options={optionsList}
                                                                index={index}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            <Field
                                                                component={NumericField}
                                                                label="Приоритет"
                                                                name={`modelOptions[${index}].priority`}
                                                                fullWidth
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            <IconButton
                                                                onClick={() => arrayHelpers.remove(index)}
                                                            >
                                                                <HighlightOffIcon/>
                                                            </IconButton>

                                                        </Grid>
                                                    </Grid>
                                                ))}
                                                <Button
                                                    fullWidth={true}
                                                    style={{marginTop: 10}}
                                                    onClick={() => arrayHelpers.push({...emptyModelOption})}
                                                >
                                                    Добавить опцию
                                                </Button>
                                            </>
                                        )}
                                    />
                                </Grid>
                            </Grid>


                            <Grid container spacing={2} className={classes.section}>
                                <Grid item xs={6}>
                                    <Typography variant="h6">Цены</Typography>
                                    { !model.prices.length && <p>Пока пусто</p> }
                                    <FieldArray
                                        name="prices"
                                        render={(arrayHelpers) => (
                                            <>
                                                { model.prices.map( (price, index) => (
                                                    <Grid key={index} container spacing={2} alignItems="center">
                                                        <Grid item xs={10}>
                                                            <ProductPriceField
                                                                prefix={`prices.${index}.`}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            <IconButton
                                                                onClick={() => arrayHelpers.remove(index)}
                                                            >
                                                                <HighlightOffIcon/>
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                )  ) }
                                                <Button
                                                    fullWidth={true}
                                                    style={{marginTop: 10}}
                                                    onClick={() => arrayHelpers.push({...emptyProductPrice})}
                                                >
                                                    Добавить цену
                                                </Button>
                                            </>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="h6">Изображения</Typography>
                                    <Field
                                        component={FileField}
                                        label="Основное изображение"
                                        name="mainImage"
                                        isImage
                                        fullWidth
                                    />
                                    <Typography variant="subtitle2" className={classes.subHeading}>Дополнительные</Typography>
                                    { !model.images.length && <p>Пока пусто</p> }
                                    <FieldArray
                                        name="images"
                                        render={(arrayHelpers) => (
                                            <>
                                                {model.images.map((value, index) => (
                                                    <Grid key={index} container spacing={2}>
                                                        <Grid item className={classes.grow}>
                                                            <Field
                                                                name={`images[${index}]`}
                                                                id={`${index}image`}
                                                                isImage
                                                                component={FileField}
                                                                label="Картинка"
                                                                fullWidth
                                                                key={`${index}image`}
                                                            />
                                                        </Grid>
                                                        <Grid item>
                                                            <IconButton
                                                                onClick={() => arrayHelpers.remove(index)}
                                                            >
                                                                <HighlightOffIcon/>
                                                            </IconButton>

                                                        </Grid>
                                                    </Grid>
                                                ))}
                                                <Button
                                                    fullWidth={true}
                                                    style={{marginTop: 10}}
                                                    onClick={() => arrayHelpers.push(null)}
                                                >
                                                    Добавить картинку
                                                </Button>
                                            </>
                                        )}
                                    />
                                </Grid>
                            </Grid>


                        </Content>
                    </Box>
                </Form>
            )}
        </Formik>
    )
}